<script setup lang="ts">
import CheckMarkIconRound from '@/assets/icons/CheckMarkIconRound.vue';
import CustomButton from '@/core/elements/CustomButton.vue';
import { ProductWithMeta } from '@/utils/billing';
import { toRefs } from 'vue';

const emit = defineEmits<{
  continue: [];
  done: [];
}>();

const props = withDefaults(
  defineProps<{
    disablePrimaryAction?: boolean;
    product?: ProductWithMeta;
    showContinue?: boolean;
  }>(),
  {
    disablePrimaryAction: false,
    product: undefined,
    showContinue: false,
  },
);

const { disablePrimaryAction, product, showContinue } = toRefs(props);

const handlePrimaryAction = (): void => {
  if (showContinue.value) {
    emit('continue');
    return;
  }

  emit('done');
};
</script>

<template>
  <div class="flex h-full min-h-0">
    <!-- sidebar -->
    <div :class="['hidden md:flex flex-col', 'bg-surface-secondary overflow-hidden', 'w-[420px] h-full shrink-0']">
      <img src="/logo-white-outline.png" class="absolute max-w-[115px] top-xxl left-xxl" />
      <img src="/assets/onboarding/finalize.png" class="w-full h-full object-cover min-h-[540px]" />
    </div>
    <!-- content -->
    <div class="flex min-w-0 flex-col w-full h-full min-h-0 md:min-h-[540px]">
      <div
        class="flex-1 min-h-0 overflow-y-auto px-xxl pt-xxl pb-md flex flex-col gap-content max-md:px-lg max-md:py-lg"
      >
        <CheckMarkIconRound :theme="'primary'" class="size-performance-level !bg-success" />
        <div>
          <h1 class="text-title font-semibold">
            {{
              $t('billing.successDialog.title', {
                product: product ? $t(product?.meta.titleKey) : undefined,
              })
            }}
          </h1>
          <span class="text-title font-medium">{{ $t('billing.successDialog.subtitle') }}</span>
        </div>
        <p>{{ $t('billing.successDialog.description') }}</p>
      </div>
      <div class="flex w-full shrink-0 justify-end px-xxl pb-xxl pt-md max-md:px-lg max-md:pb-mobile-safe-bottom-lg">
        <CustomButton
          class="max-md:w-full max-md:justify-center"
          :disabled="disablePrimaryAction"
          @click="handlePrimaryAction"
        >
          {{ $t(showContinue ? 'general.continue' : 'general.done') }}
        </CustomButton>
      </div>
    </div>
  </div>
</template>
